export default __webpack_public_path__ + "static/media/logo-name.0dbd508d.png";